<template>
  <v-container v-if="offer" :loading="loading">
    <order-overview
      :overview="overview"
      :offer-data="offerData"
      :offer="offer"
      :editable="false"
    />
    <v-row justify="end">
      <v-dialog v-model="contractDialog" persistent max-width="290">
        <template #activator="{ on }">
          <v-btn color="primary" dark style="margin-left: 2px" v-on="on">
            Vertrag erstellen
          </v-btn>
        </template>
        <v-card>
          <v-card-title class="headline">
            Vertragszeitraum eingeben
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <v-menu
                  ref="startDateMenu"
                  v-model="startDateMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template #activator="{ on, attrs }">
                    <v-text-field
                      v-model="startDate"
                      label="Startdatum"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    />
                  </template>
                  <v-date-picker
                    v-model="startDate"
                    :active-picker.sync="startDateActivePicker"
                    :max="
                      new Date(
                        new Date().setMonth(new Date().getMonth() + 6)
                      )
                        .toISOString()
                        .substr(0, 10)
                    "
                    :min="
                      new Date(
                        new Date().setMonth(new Date().getMonth() - 6)
                      )
                        .toISOString()
                        .substr(0, 10)
                    "
                  />
                </v-menu>
              </v-col>
              <v-col cols="12">
                <v-menu
                  ref="endDateMenu"
                  v-model="endDateMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template #activator="{ on, attrs }">
                    <v-text-field
                      v-model="endDate"
                      label="Enddatum"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    />
                  </template>
                  <v-date-picker
                    v-model="endDate"
                    :active-picker.sync="endDateActivePicker"
                    :max="
                      new Date(
                        new Date().setMonth(new Date().getMonth() + 66)
                      )
                        .toISOString()
                        .substr(0, 10)
                    "
                    :min="new Date().toISOString().substr(0, 10)"
                  />
                </v-menu>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="primary"
              flat
              @click.native="contractDialog = false"
            >
              Abbrechen
            </v-btn>
            <v-btn color="primary" @click="makeContract">
              speichern
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-btn
        color="primary"
        :href="route('offer.stueckliste', offer.id)"
        style="margin-right: 2px"
      >
        Download Stückliste
      </v-btn>
      <order-export :orderid="offerData.id" :termid="offer.term_id" />
      <v-btn
        color="primary"
        :href="route('offer.stueckliste', offer.id)"
        style="margin-left: 2px"
        target="_blank"
      >
        Vorleister Angebot
      </v-btn>
    </v-row>
  </v-container>
</template>

<script>
import Layout from '@/Layouts/Default'
import { formattedDateTimeString } from '@/plugins/formatDate.js'

export default {
   metaInfo () {
      // don't know your return object structure,
      // maybe you should check whole this.getViewPage
      return {
         title: this.title ? this.title : 'Angebot',
      }
   },
   layout: (h, page) => h(Layout, [page]),
   props: {
      offer: {
         type: Object,
         required: true
      },
      offerData: {
         type: Object,
         required: true
      },
      overview: {
         type: Object,
         required: true
      },
   },
   data () {
      return {
         dialog: false,
         loading: true,
         tab: 'main',
         commentInput: {
            label: '',
            text: '',
         },
         contractDialog: false,
         startDateActivePicker: 'MONTH',
         endDateActivePicker: 'YEAR',
         startDateMenu: false,
         endDateMenu: false,
         startDate: null,
         endDate: null,
      }
   },
   watch: {
      startDateMenu (val) {
         val && setTimeout(() => (this.startDateActivePicker = 'MONTH'))
      },
      endDateMenu (val) {
         val && setTimeout(() => (this.endDateActivePicker = 'YEAR'))
      },
   },
   methods: {
      async comment () {
         this.$inertia.post(
            `/offer/${this.offer.id}/status/${this.offer.offer_status[0].pivot.id}/comment`,
            this.commentInput,
            {
               preserveState: true,
               onSuccess: (page) => {
                  page.$inertia.reload({ only: ['offerstati'] })
                  console.log('success')
               },
            }
         )
      },
      getDateString (dateVal) {
         return formattedDateTimeString(dateVal)
      },
      downloadStueckliste () {
         this.$inertia.visit()
      },
      makeContract () {
         this.$inertia.post(this.route('contract.store'), {
            offer: this.offer.id,
            startDate: this.startDate,
            endDate: this.endDate,
         })
      },
   },
}
</script>
